import Marquee from "react-fast-marquee";

const items = ["Light a Lamp, Honour the Divine", "Pooja Ghee", "Pushp Oils", "Match Sticks", "Clay Toys", "Sacred Handicrafts", "Kapoor", "Indian Spices", "Festive Specials", "Poojan Dharm"];

export const EditorialMarquee = () => (
  <div className="border-y border-brand-border bg-brand-cream/50 py-7" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item) => (
        <span key={item} className="mx-10 flex items-center gap-20 font-display text-2xl italic text-brand-maroon/75 md:text-3xl">
          {item}
          <span className="text-sm not-italic text-brand-gold" aria-hidden="true">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
